import { useQuery } from "@tanstack/react-query";
import type {
  AttentionItem,
  AttentionKind,
  AttentionUrgency,
  OpenItemBucket,
  OpenItems,
} from "@/api/project-attention";
import { apiFetch } from "@/lib/api";
import { projectAttentionKeys, projectOpenItemsKeys } from "@/lib/query";

export type { AttentionItem, AttentionKind, AttentionUrgency, OpenItemBucket, OpenItems };

export function useProjectAttention(projectId: string, enabled = true) {
  return useQuery({
    queryKey: projectAttentionKeys.project(projectId),
    queryFn: () => apiFetch<AttentionItem[]>(`/projects/${projectId}/attention`),
    enabled: enabled && !!projectId,
  });
}

export function useProjectOpenItems(projectId: string, enabled = true) {
  return useQuery({
    queryKey: projectOpenItemsKeys.project(projectId),
    queryFn: () => apiFetch<OpenItems>(`/projects/${projectId}/open-items`),
    enabled: enabled && !!projectId,
  });
}
